import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from 'src/app/app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { data } from 'jquery';
import { Checklist } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-checklist-paso6',
  templateUrl: './checklist-paso6.component.html',
  styleUrls: ['./checklist-paso6.component.css']
})
export class ChecklistPaso6Component implements OnInit {
  idChecklist: number;
  idTipoRevision: number;
  checklists: Checklist[];
  title: string;
  item: object;
  rubros: any;
  bloques: any;
  bloqueEdit: any;
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  preguntaEdit: any;
  tipoRespuestas: object;
  crud: CrudHttp;
  tiposReglasNegocio: object;
  crudRule: any;
  idPreguntaPivot: number;
  idCheckboxPivot: any;
  rubroPivote: any;
  idTipoReglaNegocio: number;
  ReglaNegocioAntiguedadFecha: {
    IdRelacionPreguntaRespuesta: any;
    AntiguedadDias: any;
    FlagValidacionRespuestaPivote: boolean;
    IdRelacionPreguntaRespuestaPivote: any;
    Ponderacion: any;
  };
  ReglaNegocioRangoNumerico: {
    IdRegla: any,
    IdRelacionPreguntaRespuesta: any;
    Valor: any;
    FlagValidacionRespuestaPivote: any;
    IdRelacionPreguntaRespuestaPivote: any;
    PorcentajePermitido: any;
    Ponderacion: any;
  };
  respuestaPivot: any;
  idRelacionPivot: any;

  constructor(
    private congiService: ConfiguracionService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private father: AppComponent,
    private sanitizar: DomSanitizer
  ) {
    father.moduleName = 'Configuracion';

    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);

    this.title = 'Checklist paso 6'

    this.crud = new CrudHttp(http);
    this.crudRule = new CrudHttp(http);
    this.crud.methodGet = 'GetConfiguracionChecklist?idChecklist=' + this.idChecklist;
    this.crud.methodPut = 'UpdateRelPreguntaRespuestas';

    this.crudRule.methodPost = 'SetRelRespuestaTipoReglaNegocio';
    this.crudRule.methodDelete = 'DeleteRelRespuestaTipoReglaNegocio';

    this.ReglaNegocioAntiguedadFecha = {
      IdRelacionPreguntaRespuesta: 0,
      AntiguedadDias: '',
      FlagValidacionRespuestaPivote: false,
      IdRelacionPreguntaRespuestaPivote: null,
      Ponderacion: ''
    };

    this.ReglaNegocioRangoNumerico = {
      IdRegla: null,
      IdRelacionPreguntaRespuesta: null,
      Valor: null,
      FlagValidacionRespuestaPivote: false,
      IdRelacionPreguntaRespuestaPivote: null,
      PorcentajePermitido: null,
      Ponderacion: null
    };

    this.rubroPivote = {};
  }

  ngOnInit() {
    this.loadSubMenu();
    this.getCatalogoTiposReglasNegocio();
    this.dataBind(this.crud, 'bloques');

    this.congiService.getChecklistTipoRevision(this.idTipoRevision)
      .subscribe(resp => {
        if (resp?.Result?.Exito) {
          this.checklists = resp.Result.Data as Checklist[];
        }
      });

    $("#modalRules").on('hidden.bs.modal', function () {
      $('[name="cbPreguntasForRules"]:checked').each(function () { this.checked = false; });
    });
  }

  postRule(idRule, respuesta, preguntasChecked = null) {
    let list = [];
    switch (idRule) {
      case 1:
        this.crudRule.post({
          IdTipoReglaNegocio: idRule,
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
          ReglaNegocioDeshablilitaCargaEvidencia: {
            IdRelacionPreguntaRespuesta: respuesta.IdRelacion
          }
        })
          .then(() => {
            respuesta.TiposReglasNegocio.push({
              IdTipoReglaNegocio: idRule
            });
            Utilerias.showLoader(false);
          });
        break;
      case 2:
        list = preguntasChecked.map(function () {
          return {
            IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
            IdPreguntaDeshabilita: parseInt(this.id)
          };
        }).get();
        this.crudRule.post({
          IdTipoReglaNegocio: idRule,
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
          ReglasNegocioDeshablilitaPreguntas: list
        })
          .then(() => {
            respuesta.TiposReglasNegocio.push({
              IdTipoReglaNegocio: idRule
            });
            $('#modalRules').modal('hide');
            Utilerias.showLoader(false);
          });
        break;
      case 3:
        list = preguntasChecked.map(function () {
          return {
            IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
            IdPreguntaDinamica: parseInt(this.id)
          };
        }).get();
        this.crudRule.post({
          IdTipoReglaNegocio: idRule,
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
          ReglasNegocioPreguntasDinamicas: list
        })
          .then(() => {
            respuesta.TiposReglasNegocio.push({
              IdTipoReglaNegocio: idRule
            });
            $('#modalRules').modal('hide');
            Utilerias.showLoader(false);
          });
        break;
      case 4:
        if (this.ReglaNegocioAntiguedadFecha.FlagValidacionRespuestaPivote) {
          this.ReglaNegocioAntiguedadFecha.AntiguedadDias = null;
          this.ReglaNegocioAntiguedadFecha.IdRelacionPreguntaRespuestaPivote = parseInt($('input[name=cbRespuestasForRules]:checked')[0].id);
        } else {
          this.ReglaNegocioAntiguedadFecha.IdRelacionPreguntaRespuestaPivote = null;
        }
        this.ReglaNegocioAntiguedadFecha.IdRelacionPreguntaRespuesta = respuesta.IdRelacion;
        this.crudRule.post({
          IdTipoReglaNegocio: idRule,
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
          ReglaNegocioAntiguedadFecha: this.ReglaNegocioAntiguedadFecha
        })
          .then(() => {
            respuesta.TiposReglasNegocio.push({
              IdTipoReglaNegocio: idRule
            });
            $('#modalRuleFecha').modal('hide');
            Utilerias.showLoader(false);
          });
        break;
      case 5:
        if (this.ReglaNegocioRangoNumerico.FlagValidacionRespuestaPivote) {
          this.ReglaNegocioRangoNumerico.Valor = null;
          let id = $('input[name=cbRespuestasForRulesRN]:checked')[0].id.split('-')[1]
          this.ReglaNegocioRangoNumerico.IdRelacionPreguntaRespuestaPivote = parseInt(id);
        } else {
          this.ReglaNegocioRangoNumerico.IdRelacionPreguntaRespuestaPivote = null;
        }
        this.ReglaNegocioRangoNumerico.IdRelacionPreguntaRespuesta = respuesta.IdRelacion;
        this.crudRule.post({
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
          IdTipoReglaNegocio: idRule,
          ReglaNegocioRangoNumerico: this.ReglaNegocioRangoNumerico,
        })
          .then(() => {
            respuesta.TiposReglasNegocio.push({
              IdTipoReglaNegocio: idRule
            });
            $('#modalRuleRangoNumerico').modal('hide');
            Utilerias.showLoader(false);
          });
        break;
    }
  }

  deleteRule(idRule, respuesta) {
    this.crudRule.delete({
      r: {
        IdTipoReglaNegocio: idRule,
        IdRelacionPreguntaRespuesta: respuesta.IdRelacion,
        ReglaNegocioDeshablilitaCargaEvidencia: {
          IdRelacionPreguntaRespuesta: respuesta.IdRelacion
        }
      }
    })
      .then(() => {
        respuesta.TiposReglasNegocio = respuesta.TiposReglasNegocio
          .filter(x => x.IdTipoReglaNegocio != idRule);
        Utilerias.showLoader(false);
      });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Paso 1',
        router: `../../../ChecklistPaso1/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 2',
        router: `../../../ChecklistPaso2/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 3',
        router: `../../../ChecklistPaso3/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 4',
        router: `../../../ChecklistPaso4/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 5',
        router: `../../../ChecklistPaso5/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Paso 6',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  getCatalogoTiposReglasNegocio() {
    Utilerias.httpRequest(this.http, 'GetCatalogoTipoReglaNegocios')
      .then(res => {
        this.tiposReglasNegocio = res;
      });
  }

  configRule(rubroPivote, idPreguntaPivot, respuesta, idTipoReglaNegocio, idCheckboxPivot) {
    this.idTipoReglaNegocio = idTipoReglaNegocio
    this.idPreguntaPivot = idPreguntaPivot
    this.idCheckboxPivot = idCheckboxPivot;
    this.respuestaPivot = respuesta;
    this.idRelacionPivot = respuesta.IdRelacion;
    switch (idTipoReglaNegocio) {
      case 2:
        this.loadRule2(respuesta);
        break;
      case 3:
        this.loadRule3(respuesta);
        break;
      case 4:
        this.rubroPivote = rubroPivote;
        this.loadRule4(respuesta);
        break;
      case 5:
        this.rubroPivote = rubroPivote;
        this.loadRule5(respuesta);
        break;
    }
  }

  loadRule2(respuesta) {
    Utilerias.httpRequest(this.http, 'GetReglaNegocioDeshablilitaPreguntas?idRelacionPreguntaRespuesta=' + respuesta.IdRelacion)
      .then((res: any) => {
        Utilerias.showLoader(false);
        for (var pregunta of res) {
          let preguntaDesh = this.sanitizar.sanitize(SecurityContext.HTML, "#" + pregunta.IdPreguntaDeshabilita);
          let $_preguntaDesh = $(preguntaDesh);
          $_preguntaDesh.prop('checked', true);
        }
        $('#modalRules').modal('show');
      })
  }

  loadRule3(respuesta) {
    Utilerias.httpRequest(this.http, 'GetReglaNegocioPreguntaDinamicas?idRelacionPreguntaRespuesta=' + respuesta.IdRelacion)
      .then((res: any) => {
        Utilerias.showLoader(false);
        for (var pregunta of res) {
          // let preg =
          let _pregunta = this.sanitizar.sanitize(SecurityContext.HTML, "#" + pregunta.IdPreguntaDinamica);
          let $_pregunta = $(_pregunta);
          $_pregunta.prop('checked', true);
        }
        $('#modalRules').modal('show');
      })
  }

  loadRule4(respuesta) {
    Utilerias.httpRequest(this.http, 'GetReglaNegocioAntiguedadFecha?idRelacionPreguntaRespuesta=' + respuesta.IdRelacion)
      .then((res: any) => {
        Utilerias.showLoader(false);
        if (res != null) {
          if (res.IdRelacionPreguntaRespuestaPivote != null) {
            let respPivote = this.sanitizar.sanitize(SecurityContext.HTML, '#' + res.IdRelacionPreguntaRespuesta);
            let $_respPivote = $(respPivote)
            $_respPivote.prop('checked', true);
          }
          this.ReglaNegocioAntiguedadFecha = res;
        } else {
          this.ReglaNegocioAntiguedadFecha = {
            IdRelacionPreguntaRespuesta: null,
            AntiguedadDias: '',
            FlagValidacionRespuestaPivote: false,
            IdRelacionPreguntaRespuestaPivote: null,
            Ponderacion: ''
          };
        }
        $('#modalRuleFecha').modal('show');
      })
  }

  loadRule5(respuesta) {
    Utilerias.httpRequest(this.http, 'GetReglaNegocioRangoNumerico?idRelacionPreguntaRespuesta=' + respuesta.IdRelacion)
      .then((res: any) => {
        Utilerias.showLoader(false);
        if (res != null) {
          if (res.IdRelacionPreguntaRespuestaPivote != null) {
            let respivote = this.sanitizar.sanitize(SecurityContext.HTML, "#" + res.IdRelacionPreguntaRespuestaPivote);
            let $_respPivote = $(respivote);
            $_respPivote.prop('checked', true);
          }
          this.ReglaNegocioRangoNumerico = res;
        } else {
          this.ReglaNegocioRangoNumerico = {
            IdRegla: null,
            IdRelacionPreguntaRespuesta: null,
            Valor: null,
            FlagValidacionRespuestaPivote: false,
            IdRelacionPreguntaRespuestaPivote: null,
            PorcentajePermitido: null,
            Ponderacion: null
          };
        }
        $('#modalRuleRangoNumerico').modal('show');
      })
  }

  formRules(event) {
    event.preventDefault();
    let PreguntasChecked = $('[name="cbPreguntasForRules"]:checked');
    if (![4, 5].includes(this.idTipoReglaNegocio) && PreguntasChecked.length == 0) {
      Utilerias.alertClient('', 'Debes de seleccionar por lo menos una pregunta', 1);
      return;
    }
    this.postRule(this.idTipoReglaNegocio, this.respuestaPivot, PreguntasChecked);
  }

  dataBind(crud, sourceName) {
    crud.get()
      .then(res => {
        this[sourceName] = res;
        Utilerias.showLoader(false);
      });
  }

  existsRule(collection, id) {
    return (collection.find(x => x.IdTipoReglaNegocio == id) ? true : false);
  }

  restrictionRespuestaTipoRegla(idTipoInput, idTipoReglaNegocio) {
    let combinations = [
      '7-1',
      '7-2',
      '2-3',
      '2-5',
      '6-4',
    ];
    return combinations.includes(idTipoInput + '-' + idTipoReglaNegocio);
  }

  publicar() {
    Utilerias.alertConfirm('Ya no podras modificar el checklist', '<h2>¿Deseas publicar el checklist?</h2>')
      .then(res => {
        if (res.isConfirmed) {
          const found = this.checklists.find(item => item.IdEtapa === 3);
          // const thereIsAPublication = typeof found === 'object' ?? false;

          if (found)
            Utilerias.alertClient('<h2>Ya existe un checklist publicado</h2>', 'Debes desactivar el checklist actual para publicar uno nuevo', 1)
          else {
            this.congiService.updateStatusChecklist(this.idChecklist)
              .subscribe(data => {
                if (data.Result.Exito) {
                  this.router.navigate(["Configuracion/ChecklistConfiguracion", this.idTipoRevision]);
                }
              })
          }
        }
      });
  }
}
